module.exports = __webpack_public_path__ + "img/shop_default.bba299e5.png";